module.exports = __webpack_public_path__ + "media/images/hitfun3/bg.prizehistory.certificate-fc2d9cb0d8cae91f72bd236fd7a5b2bf.svg";